export default {
    'inch-token-cross-chain-item.network': 'Network',
    'inch-token-cross-chain-item.networks': 'Networks',
};
//# sourceMappingURL=en.js.map